export const environment = {
  production: false,
  apiUrl: 'https://savant-switch-qa-16501656414.europe-west2.run.app/api/v1',
};
